<div class="quote-result">

    <!-- Resumen de la cotización -->
    <div class="quote-request-details">
        <div class="detail-item">
            <span class="detail-label">Alquiler</span>
            <span class="detail-value">$ {{ utilsService.beautifyNumber(quote.alquiler, 2) }}</span>
        </div>
        <div class="detail-item">
            <span class="detail-label">Expensas</span>
            <span class="detail-value">$ {{ utilsService.beautifyNumber(quote.expensas, 2) }}</span>
        </div>
        <div class="detail-item">
            <span class="detail-label">Tipo</span>
            <span class="detail-value">{{ utilsService.beautifyText(quote.tipo.toLowerCase()) }}</span>
        </div>
        <div class="detail-item">
            <span class="detail-label">Plazo</span>
            <span class="detail-value">{{ quote.duracion }} meses</span>
        </div>
        <div class="detail-item" *ngIf="quote.tipoDescuento && quote.tipoDescuento !== 'NORMAL'">
            <span class="detail-label">Descuento</span>
            <span class="detail-value discount-badge">{{ quote.tipoDescuento }}</span>
        </div>
        <div class="detail-item" *ngIf="quote.comisionMonto !== undefined && quote.comisionMonto !== null">
            <span class="detail-label">Comisión{{ quote.comisionPct ? ' (' + (quote.comisionPct | number:'1.0-0') + '%)' : '' }}</span>
            <span class="detail-value">$ {{ utilsService.beautifyNumber(quote.comisionMonto, 2) }}</span>
        </div>
    </div>

    <!-- Coberturas por servicio -->
    <div class="coverage-section" *ngIf="quote.servicios?.length">
        <h4 class="section-title">Coberturas</h4>
        <table class="coverage-table">
            <thead>
                <tr>
                    <th>Servicio</th>
                    <th>Cobertura (Valor C)</th>
                    <th>Precio</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let s of quote.servicios">
                    <td>{{ utilsService.beautifyText(s.nombre) }}</td>
                    <td>{{ s.valorC != null ? ('$ ' + utilsService.beautifyNumber(s.valorC, 2)) : '—' }}</td>
                    <td class="price-cell">$ {{ utilsService.beautifyNumber(s.monto, 2) }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Toggle sin pago en efectivo -->
    <div class="sin-efectivo-toggle">
        <mat-checkbox [(ngModel)]="sinPagoEfectivo" color="primary">
            Sin Pago en Efectivo
        </mat-checkbox>
    </div>

    <!-- Opciones de pago -->
    <div class="payment-options">

        <!-- Efectivo (solo si sinPagoEfectivo es false) -->
        <ng-container *ngIf="!sinPagoEfectivo">
            <div class="payment-card efectivo" *ngFor="let opt of getEfectivoOptions()">
                <span class="payment-discount" [class.negativo]="opt.tasa < 0" *ngIf="opt.tasa !== undefined && opt.tasa !== null">{{ opt.tasa | number:'1.0-0' }}%</span>
                <span class="payment-icon">💵</span>
                <span class="payment-name">Efectivo</span>
                <span class="payment-amount">$ {{ utilsService.beautifyNumber(opt.montoTotal, 0) }}</span>
                <span class="payment-installments" *ngIf="opt.cuotas > 1">
                    {{ opt.cuotas }} cuotas de $ {{ utilsService.beautifyNumber(opt.montoPorCuota, 0) }}
                </span>
            </div>
        </ng-container>

        <!-- Transferencia -->
        <div class="payment-card transferencia" *ngFor="let opt of getOptionsByType('TRANSFERENCIA')">
            <span class="payment-discount" [class.negativo]="opt.tasa < 0" *ngIf="opt.tasa !== undefined && opt.tasa !== null">{{ opt.tasa | number:'1.0-0' }}%</span>
            <span class="payment-icon">🏦</span>
            <span class="payment-name">Transferencia bancaria</span>
            <span class="payment-amount">$ {{ utilsService.beautifyNumber(opt.montoTotal, 0) }}</span>
            <span class="payment-installments" *ngIf="opt.cuotas > 1">
                {{ opt.cuotas }} cuotas de $ {{ utilsService.beautifyNumber(opt.montoPorCuota, 0) }}
            </span>
        </div>

        <!-- Débito -->
        <div class="payment-card debito" *ngFor="let opt of getOptionsByType('DEBITO')">
            <span class="payment-discount" [class.negativo]="opt.tasa < 0" *ngIf="opt.tasa !== undefined && opt.tasa !== null">{{ opt.tasa | number:'1.0-0' }}%</span>
            <span class="payment-icon">💳</span>
            <span class="payment-name">Tarjeta de Débito</span>
            <span class="payment-amount">$ {{ utilsService.beautifyNumber(opt.montoTotal, 0) }}</span>
            <span class="payment-installments" *ngIf="opt.cuotas > 1">
                {{ opt.cuotas }} cuotas de $ {{ utilsService.beautifyNumber(opt.montoPorCuota, 0) }}
            </span>
        </div>

        <!-- Crédito -->
        <div class="payment-card credito" *ngFor="let opt of getOptionsByType('CREDITO')">
            <span class="payment-discount" [class.negativo]="opt.tasa < 0" *ngIf="opt.tasa !== undefined && opt.tasa !== null && opt.cuotas !== 12">{{ opt.tasa | number:'1.0-0' }}%</span>
            <span class="payment-icon">💳</span>
            <span class="payment-name">
                {{ opt.cuotas > 1 ? 'Tarjeta de Crédito' : 'Crédito en un Pago' }}
                <span class="installments-label" *ngIf="opt.cuotas > 1">{{ opt.cuotas }} cuotas</span>
            </span>
            <span class="payment-amount">$ {{ utilsService.beautifyNumber(opt.montoTotal, 0) }}</span>
            <span class="payment-installments" *ngIf="opt.cuotas > 1">
                {{ opt.cuotas }} cuotas de $ {{ utilsService.beautifyNumber(opt.montoPorCuota, 0) }}
            </span>
        </div>

    </div>

    <!-- Acciones -->
    <div class="quote-actions">
        <span class="action-link" (click)="openSendByEmailDialog()" *ngIf="quote?.id">
            <mat-icon>send</mat-icon>
            <span>Enviar por email</span>
        </span>
        <span class="action-link pdf-link" *ngIf="quote?.id" (click)="downloadPdf()">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>Generar PDF</span>
        </span>
    </div>

</div>
